import { formatTimeAgo, escapeHtml } from '../../utils/helpers';

export default class NotificationsView {
  constructor() {
    this.eventHandlers = {};
  }

  async render() {
    return `
      <div id="page-notifications" class="page-content active">
          <section class="create-wrapper" aria-labelledby="notifications-actions-title">
              <h2 id="notifications-actions-title" class="sr-only">Aksi Notifikasi</h2>
              <button type="button" id="enable-notifications-page" class="post-submit" data-text_tip="Aktifkan notifikasi push" data-hover_tip="bottom" data-dev_tip="desktop">
                  <span class="material-symbols-rounded" aria-hidden="true">notifications_active</span>
                  <span>Aktifkan Notifikasi</span>
              </button>
          </section>
          <section class="post-wrapper" aria-labelledby="notifications-list-title">
              <h2 id="notifications-list-title" class="sr-only">Daftar Notifikasi</h2>
              <div class="post-list" id="notifications-container">
                  <div class="loading-post">
                      <div class="hg-animate" aria-hidden="true"></div>
                      <p>Memuat notifikasi...</p>
                  </div>
              </div>
          </section>
      </div>
    `;
  }

  async afterRender() {
    // Setup handled by presenter
  }

  setupNotificationButtonEventListener(onToggleNotifications) {
    const button = document.querySelector('#enable-notifications-page');
    if (button) {
      this.eventHandlers.notificationButtonHandler = onToggleNotifications;
      button.addEventListener('click', this.eventHandlers.notificationButtonHandler);
    }
  }

  setupNotificationInteractionEventListeners(onDeleteNotification) {
    this.eventHandlers.globalClickHandler = (e) => {
      const deleteBtn = e.target.closest('.delete-notification');
      if (deleteBtn) {
        e.stopPropagation();
        const notificationId = deleteBtn.dataset.notificationId;
        onDeleteNotification(notificationId);
        return;
      }
    };
    
    document.addEventListener('click', this.eventHandlers.globalClickHandler);
  }

  showLoading(container) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (container) {
      container.innerHTML = `
        <div class="loading-post">
          <div class="hg-animate" aria-hidden="true"></div>
          <p>Memuat notifikasi...</p>
        </div>
      `;
    }
  }

  showEmptyState(container, message) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (container) {
      container.innerHTML = `
        <div class="empty-state">
          <span class="material-symbols-rounded" aria-hidden="true">inbox</span>
          <h3>Tidak ada konten</h3>
          <p>${message}</p>
        </div>
      `;
    }
  }

  showAuthRequired(container) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (container) {
      container.innerHTML = `
        <div class="auth-required">
          <span class="material-symbols-rounded" aria-hidden="true">login</span>
          <h3>Masuk diperlukan</h3>
          <p>Silakan masuk atau daftar untuk melihat notifikasi</p>
          <button class="login-btn" onclick="app.navigateTo('auth')" aria-label="Masuk sekarang">
            <span class="material-symbols-rounded" aria-hidden="true">login</span>
            Masuk Sekarang
          </button>
        </div>
      `;
    }
  }

  renderNotifications(notifications, container) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (!container) return;

    container.innerHTML = '';
    
    if (notifications.length === 0) {
      this.showEmptyState(container, 'Belum ada notifikasi');
      return;
    }

    let notificationsHtml = '';
    notifications.forEach(notification => {
      const timeAgo = formatTimeAgo(notification.timestamp);
      
      notificationsHtml += `
        <article class="postingan" data-notification-id="${notification.id}">
          <div class="post-user">
            <div class="user-sender">
              <div class="poster-photo">
                <span class="material-symbols-rounded" style="font-size: 2rem; color: var(--primary);">notifications</span>
              </div>
              <div class="sender-post">
                <h3>${escapeHtml(notification.title)}</h3>
                <p style="color: var(--text-secondary); font-size: 0.875rem;">${timeAgo}</p>
              </div>
            </div>
            <div class="time-post">
              <button class="delete-notification" data-notification-id="${notification.id}" data-text_tip="Hapus notifikasi" data-hover_tip="left" data-dev_tip="desktop" aria-label="Hapus notifikasi">
                <span class="material-symbols-rounded" aria-hidden="true">close</span>
              </button>
            </div>
          </div>
          <div class="isi-postingan">
            <div class="post-text">${escapeHtml(notification.message)}</div>
          </div>
        </article>
      `;
    });
    
    container.innerHTML = notificationsHtml;
  }

  updateNotificationButton(isSubscribed) {
    const button = document.querySelector('#enable-notifications-page');
    if (!button) return;

    if (isSubscribed) {
      button.innerHTML = `
        <span class="material-symbols-rounded" aria-hidden="true">notifications_off</span>
        <span>Nonaktifkan Notifikasi</span>
      `;
      button.setAttribute('data-text_tip', 'Nonaktifkan notifikasi push');
    } else {
      button.innerHTML = `
        <span class="material-symbols-rounded" aria-hidden="true">notifications_active</span>
        <span>Aktifkan Notifikasi</span>
      `;
      button.setAttribute('data-text_tip', 'Aktifkan notifikasi push');
    }
  }

  showNotificationPermissionStatus(status, container) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (!container) return;

    let message = '';
    let iconColor = 'var(--text-secondary)';

    switch (status) {
      case 'granted':
        message = 'Notifikasi diizinkan. Anda akan menerima notifikasi untuk aktivitas terbaru.';
        iconColor = 'var(--success)';
        break;
      case 'denied':
        message = 'Notifikasi diblokir. Aktifkan melalui pengaturan browser untuk menerima notifikasi.';
        iconColor = 'var(--error)';
        break;
      case 'default':
        message = 'Klik tombol di atas untuk mengaktifkan notifikasi push.';
        break;
      case 'not-supported':
        message = 'Browser Anda tidak mendukung notifikasi push.';
        iconColor = 'var(--warning)';
        break;
    }

    const statusDiv = document.createElement('div');
    statusDiv.className = 'notification-status';
    statusDiv.style.cssText = 'padding: 1rem; margin-bottom: 1rem; background: var(--bg-container); border-radius: var(--radius-m); text-align: center;';
    statusDiv.innerHTML = `
      <span class="material-symbols-rounded" style="color: ${iconColor}; font-size: 2rem; display: block; margin-bottom: 0.5rem;">notifications</span>
      <p style="color: var(--text-secondary); margin: 0;">${message}</p>
    `;

    container.insertBefore(statusDiv, container.firstChild);
  }

  removeNotificationFromDOM(notificationId) {
    const notificationElement = document.querySelector(`[data-notification-id="${notificationId}"]`);
    if (notificationElement) {
      notificationElement.remove();
    }
  }

  cleanupEventListeners() {
    const button = document.querySelector('#enable-notifications-page');
    if (button && this.eventHandlers.notificationButtonHandler) {
      button.removeEventListener('click', this.eventHandlers.notificationButtonHandler);
    }

    if (this.eventHandlers.globalClickHandler) {
      document.removeEventListener('click', this.eventHandlers.globalClickHandler);
    }

    this.eventHandlers = {};
  }

  cleanup() {
    this.cleanupEventListeners();
  }
}